import React, { useEffect, useState } from "react";
import { Typography, ScalableImage, useDevice } from "design_system/src";

export interface PaymentItemProps {
  title: React.ReactNode;
  text: React.ReactNode;
  imageUrl: string;
  desktopImageUrl: string;
  imageAlt: string;
}

const PaymentItem: React.FC<PaymentItemProps> = ({
  title,
  text,
  imageUrl,
  desktopImageUrl,
  imageAlt,
}) => {
  const { isMobile: isDeviceMobile, isTablet: isDeviceTablet, isLoading } = useDevice();
  const [isMobile, setIsMobile] = useState<boolean>();
  const [isTablet, setIsTablet] = useState<boolean>();
  const [imgUrl, setImgUrl] = useState<string>();

  useEffect(() => {
    if (!isLoading) {
      setIsMobile(isDeviceMobile);
      setIsTablet(isDeviceTablet);
    }

  }, [isDeviceMobile, isDeviceTablet, isLoading]);

  useEffect(() => {
    if (isMobile !== undefined) {
      setImgUrl(isMobile ? imageUrl : desktopImageUrl);
    }

  }, [isMobile]);

  return (
    <div className="display_flex flex_col_mobile flex_justify_between h_100_per pos_relative">
      {/* text */}
      <div className="w_100_per w_50_per_desktop display_flex flex_col flex_justify_evenly m_b_xxl_desktop p_lg p_xxxl_desktop">
        <Typography
          weight="600"
          scale="heading3"
          scaleMobile="heading4"
          className="m_b_md"
        >
          {title}
        </Typography>
        <Typography
          weight="400"
          scale="large"
          scaleMobile="medium"
        >
          {text}
        </Typography>
      </div>

      {/* image */}
      {imgUrl && isMobile && <div className="w_100_per w_50_per_desktop">
        <ScalableImage
          className="img_contain display_block"
          src={imgUrl}
          alt={imageAlt}
        />
      </div>}

      {imgUrl && !isMobile && (
        <div
          className="pos_absolute h_100_per w_50_per"
          style={{
            bottom: 0,
            right: 0,
          }}
        >
          <ScalableImage
            className="img_contain"
            src={imgUrl}
            style={{
              height: "100%",
              objectFit: isTablet ? "cover": "contain",
              objectPosition: isTablet ? "left top": "right top"
            }}
            alt={imageAlt}
          />
        </div>
      )}
    </div>
  );
};

export default PaymentItem;
